export { useTransition, useDeferredValue, useId, useSyncExternalStore, useInsertionEffect } from 'react';
export { hydrateRoot } from './entries/18/client';
